<script>
import FireIcon from "@/assets/images/svg/icons/fire.svg";
import CoinPackage from "@/components/cards/CoinPackage.vue";

export default {
  name: "index.vue",

  components: {
    CoinPackage,
    FireIcon,
  },

  computed: {
    popularPacks() {
      return [
        {
          group: "Promo",
          key: "-O5YDR7OqxWIt2vesWrY",
          price: 1000,
          label: "$10",
          MMC: 1000,
          MQC: 10000000,
          bonus: 1000,
        },
        {
          group: "Promo",
          key: "-A1B2C3D4E5F6G7H8I9J0",
          price: 2000,
          label: "$20",
          MMC: 2000,
          MQC: 20000000,
          bonus: 2000,
        },
        {
          group: "Promo",
          key: "-Z9Y8X7W6V5U4T3S2R1Q0",
          price: 3000,
          label: "$30",
          MMC: 3000,
          MQC: 30000000,
          bonus: 3000,
        },
      ];
    },
    allPacks() {
      return [
        {
          group: "Promo",
          key: "-O5YDR7OqxWIt2vesWrY",
          price: 1000,
          label: "$10",
          MMC: 1000,
          MQC: 10000000,
          bonus: 1000,
        },
        {
          group: "Promo",
          key: "-A1B2C3D4E5F6G7H8I9J0",
          price: 2000,
          label: "$20",
          MMC: 2000,
          MQC: 20000000,
          bonus: 2000,
        },
        {
          group: "Promo",
          key: "-Z9Y8X7W6V5U4T3S2R1Q0",
          price: 3000,
          label: "$30",
          MMC: 3000,
          MQC: 30000000,
          bonus: 3000,
        },
        {
          group: "Promo",
          key: "-K1L2M3N4O5P6Q7R8S9T0",
          price: 4000,
          label: "$40",
          MMC: 4000,
          MQC: 40000000,
          bonus: 4000,
        },
        {
          group: "Promo",
          key: "-U1V2W3X4Y5Z6A7B8C9D0",
          price: 5000,
          label: "$50",
          MMC: 5000,
          MQC: 50000000,
          bonus: 5000,
        },
        {
          group: "Promo",
          key: "-E1F2G3H4I5J6K7L8M9N0",
          price: 6000,
          label: "$60",
          MMC: 6000,
          MQC: 60000000,
          bonus: 6000,
        },
      ];
    },
  },
};
</script>

<template>
  <div class="page-container">
    <img
      class="w-full"
      :src="
        $vuetify.breakpoint.xsOnly
          ? '/images/banners/coin-store-mini.png?v1'
          : '/images/banners/coin-store.png'
      "
      alt="coin-store"
    />

    <div class="mt-8 mt-sm-15">
      <p class="d-flex align-center title white--text">
        <FireIcon />
        <span class="ml-3">Most Popular</span>
      </p>
    </div>

    <div class="packages-group">
      <coin-package
        v-for="(slide, n) in popularPacks" :key="n"
        :highlighted="n === popularPacks.length - 1"
        :item="slide"
      />
    </div>

    <div class="mt-8 mt-sm-15">
      <p class="d-flex align-center title white--text">
        <FireIcon />
        <span class="ml-3">More coin packs below</span>
      </p>
    </div>

    <div class="packages-group">
      <coin-package
        v-for="(slide, n) in allPacks" :key="n"
        :highlighted="n === allPacks.length - 1"
        :item="slide"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-container {
  background: #8879B7;
  padding: 60px;

  @media screen and (max-width: 600px) {
    padding: 20px 20px 120px;
  }
}

.packages-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(490px, 1fr));
  gap: 15px;
  width: 100%;
  margin-top: 12px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
